import React from "react"
import ContentLoader from "react-content-loader";

const TableColumn = (props) => {
    return(
        <ContentLoader
            height={30}
            width={'100'}
            backgroundColor="#eee"
            foregroundColor="#ecebeb"
            {...props}>
        <rect x="1" y="10" rx="5" ry="5" width="100" height="50" />        
      </ContentLoader>
    )
}
TableColumn.metadata = {
    name: 'DaniloWoz',
    github: 'DaniloWoz',
    description: 'Simple Article',
    filename: 'EmailListing',
  }
export default TableColumn;